import {
    Flex, Image, Text
} from '@chakra-ui/react';
import { t } from '@lingui/macro';
import React from 'react';

import errorImage from '../../../assets/icons/404-guy.gif';
import { useSelectorProfileLocale } from '../../app';

export function ErrorView () {
    const { isLocaleLoaded } = useSelectorProfileLocale();

    return (
        <Flex
            data-testid={'error-view'}
            width={'100%'}
            height={'100%'}
            direction={'column'}
            align={'center'}
            justify={'center'}
        >
            <Image
                src={errorImage}
                width={200}
                alt={'error'}
            />
            <Text fontSize={'5xl'}>{isLocaleLoaded ? t`error.header`: '2 + 2 = 5?'}</Text>
            <Text>{isLocaleLoaded ? t`error.content` : 'Sorry, something\'s not adding up.'}</Text>
            <Text>{isLocaleLoaded ? t`error.footer` : 'We are working to solve the problem.'}</Text>
        </Flex>
    );
}
